
import React from 'react';

export default function WhistlerHero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative pt-36 pb-24 lg:pt-44 lg:pb-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/22a18139d041bdea64e27674c3efc33d.jpg"
          alt="Whistler Village"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <h1 className="font-['Fraunces'] text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Whistler Short Term Rental Rules &amp; Regulations 2026
        </h1>
        <p className="text-xl lg:text-2xl text-white/90 mb-8 max-w-4xl mx-auto leading-relaxed">
          Navigate Canada&apos;s premier ski resort STR regulations with confidence. Understand Whistler&apos;s unique zoning system, Tourist Accommodation designation requirements, and compliance strategies for this world-class destination.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={scrollToContact}
            className="bg-[#882629] text-white px-10 py-5 rounded-full text-lg font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl"
          >
            Get Whistler Compliance Help
          </button>
          <a
            href="#licensing"
            className="bg-white/10 backdrop-blur-sm text-white px-10 py-5 rounded-full text-lg font-medium hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap border-2 border-white/30"
          >
            View Licensing Requirements
          </a>
        </div>
      </div>
    </section>
  );
}
